import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  LabelList,
  CartesianGrid
} from "recharts";

// const data = [
//   { reason: "Refused Delivery", value: 53.5 },
//   { reason: "Address Closed", value: 16.38 },
//   { reason: "Bad Address", value: 10.81 },
//   { reason: "Hold for Self-collection", value: 10.0 },
//   { reason: "No Such Consignee", value: 4.06 },
//   { reason: "NO REASON CAPTURED", value: 2.69 },
//   { reason: "Non Service Area", value: 2.38 },
//   { reason: "Consignee Shifted", value: 0.19 },
// ];

function CustomTooltip({ payload, label, active }) {
  if (active && payload && payload.length) {
    return (
      <div
        className="custom-tooltip"
        style={{
          border: '1px solid #d88488',
          backgroundColor: '#fff',
          padding: '10px',
          borderRadius: '5px',
          boxShadow: '1px 1px 2px #d88488',
        }}
      >
        <p className="label" style={{ margin: '0', fontWeight: '700' }}>{`${label} : ${payload[0].value}%`}</p>
        <p className="label" style={{ margin: '0', fontWeight: '700' }}>{`Total Shipment : ${payload[0]?.payload?.counts}`}</p>
      </div>
    );
  }

  return null;
}

const ReturnReasonsChart = ({returnReasons : data}) => {
  return (
    <div
      style={{
        background: "linear-gradient(to bottom, #666, #555)",
        borderRadius: "15px",
        padding: "20px",
        width: "100%",
        height: "400px",
      }}
    >
      {/* <h3
        style={{
          textAlign: "center",
          color: "white",
          marginBottom: "10px",
          fontWeight: "bold",
        }}
      >
        Return Reasons
      </h3> */}

      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          layout="vertical"
          data={data}
          margin={{ top: 20, right: 40, left: 20, bottom: 20 }}
          barSize={20}
        >
          <CartesianGrid stroke="rgba(255,255,255,0.1)" horizontal={false} />
          <XAxis
            type="number"
            domain={[0, 60]}
            stroke="#fff"
            tickFormatter={(val) => `${val}%`}
          />
          <YAxis
            type="category"
            dataKey="reason"
            stroke="#fff"
            width={150}
          />
          <Tooltip content={CustomTooltip}  defaultIndex={2} active  />

          <defs>
            <linearGradient id="orangeGrad" x1="0" y1="0" x2="1" y2="0">
              <stop offset="0%" stopColor="#FF7C47" />
              <stop offset="100%" stopColor="#FFB088" />
            </linearGradient>
          </defs>

          <Bar dataKey="returnRatio" fill="url(#orangeGrad)" radius={[0, 5, 5, 0]}>
            <LabelList
              dataKey="returnRatio"
              position="right"
              formatter={(val) => `${val}%`}
              fill="white"
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ReturnReasonsChart;